import { ISpotBase } from '../../models/spots';
import { IVentureBase } from '../../models/ventures';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IListSpotProps {
  isActive?: boolean;
  name?: string;
  sort?: 'name' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export interface ISpotListItem extends ISpotBase {
  venture: IVentureBase;
}

export interface ISpotList {
  items: ISpotListItem[];
  pages: number;
  total: number;
}

export const listSpotsService = async (
  filters?: IListSpotProps,
): Promise<ISpotList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          isActive: filters.isActive,
          name: filters.name || undefined,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await wbsBookingsApi.get<ISpotList>('/spots', {
    params,
  });

  return data;
};
